import { queryOptions, useMutation } from "@tanstack/react-query";
import {
    fetchOrderImages,
    getUnbilledOrders,
    postCompleteEnqueuedOrder,
    postEnqueueOrder,
    postOrderDocument,
    postOrderNote,
} from "./mvte.api";
import { queryClient } from "src/lib/react-query";

export function unbilledOrdersQueryOptions({
    queueName,
    orderStatuses,
}: {
    queueName: string;
    orderStatuses?: string[];
}) {
    return queryOptions({
        queryKey: ["unbilled-orders", { queueName, orderStatuses }],
        queryFn: () => getUnbilledOrders({ queueName, orderStatuses }),
    });
}

export function orderImagesQueryOptions({
    orderNumber,
}: {
    orderNumber: string;
}) {
    return queryOptions({
        queryKey: ["orders", orderNumber, "images"],
        queryFn: () => fetchOrderImages({ orderNumber }),
    });
}

export function useCreateOrderNote({ orderNumber }: { orderNumber: string }) {
    return useMutation({
        mutationKey: ["orders", orderNumber, "notes"],
        mutationFn: postOrderNote,
        onSuccess: () => queryClient.invalidateQueries(),
    });
}

export function useCreateOrderDocument({
    orderNumber,
}: {
    orderNumber: string;
}) {
    return useMutation({
        mutationKey: ["orders", orderNumber, "images"],
        mutationFn: postOrderDocument,
        onSuccess: () => queryClient.invalidateQueries(),
    });
}

export function useEnqueueOrder({ orderNumber }: { orderNumber: string }) {
    return useMutation({
        mutationKey: ["unbilled-orders", orderNumber, "enqueue"],
        mutationFn: postEnqueueOrder,
        onSuccess: () => queryClient.invalidateQueries(),
    });
}

export function useCompleteEnqueuedOrder({
    orderNumber,
}: {
    orderNumber: string;
}) {
    return useMutation({
        mutationKey: ["unbilled-orders", orderNumber, "complete-queue"],
        mutationFn: postCompleteEnqueuedOrder,
        onSuccess: () => queryClient.invalidateQueries(),
    });
}
